import { SET_DISPLAY_CARRIERS } from '../../actions/actionTypes'

const defaultState = {
  displayCarriers: [],
  airlineTable: {}
}

const mapToArray = (map = []) => {
  return Array.from(map).reduce(
    (obj, [key, value]) => Object.assign(obj, { [key]: value }),
    {}
  )
}

const airlines = (state = defaultState, action) => {
  switch (action.type) {
    case SET_DISPLAY_CARRIERS:
      return Object.assign({}, state, {
        displayCarriers: action.displayCarriers
      })
    default:
      return state
  }
}

export { airlines, mapToArray }
